import { observer } from 'mobx-react-lite'
import { DependentProfilesDialog } from './index'
import type { DependentsInfoRequestedSupportingItemViewModel } from '../../DependentsInfoRequestedSupportingItemViewModel'
import { DependentProfileEditorDialogContainer } from '@/features/tax-profile/individual-profiles/components/DependentProfileEditorDialog'
import { DependentProfileCardListSectionContainer } from '@/features/jobs/details/tax-type/info-gathering/dependents-info/components/DependentProfileCardListSection/DependentProfileCardListSectionContainer'
import { RemoveDependentDialogContainer } from '@/features/jobs/details/tax-type/info-gathering/dependents-info/components/RemoveDependentDialog/RemoveDependentDialogContainer'

export interface DependentProfilesDialogContainerProps {
  vm: DependentsInfoRequestedSupportingItemViewModel
  isDisabled?: boolean
}

/**
 * Container for the DependentProfilesDialog that wires up the view model.
 */
export const DependentProfilesDialogContainer = observer(
  function DependentProfilesDialogContainer({
    vm,
    isDisabled,
  }: DependentProfilesDialogContainerProps) {
    return (
      <>
        <DependentProfilesDialog
          isOpen={vm.dependentsDialog.showing}
          onClose={vm.dependentsDialog.close}
          isEmpty={vm.isEmpty}
        >
          <DependentProfileCardListSectionContainer
            vm={vm}
            isDisabled={isDisabled}
          />
        </DependentProfilesDialog>

        <DependentProfileEditorDialogContainer
          vm={vm.dependentEditorVm}
          isDisabled={isDisabled}
        />
        <RemoveDependentDialogContainer vm={vm} />
      </>
    )
  },
)
